import { logEvent } from 'commons/utils/tracking';
import {
  ADD_DOMAIN_CLICK,
  CREATE_DOMAIN_SUBMIT_CLICK,
  DELETE_DOMAIN_CLICK,
  DOMAINS_ERROR_ALERT_DASHBOARD_CLICK,
  DOMAINS_ERROR_ALERT_DASHBOARD_DISMISS,
  DOMAINS_ERROR_ALERT_DASHBOARD_SHOW,
  DOMAIN_ERROR_REVIEW_CLICK,
  NUVEM_DOMAINS_AVAILABLE,
  NUVEM_DOMAINS_BUY_CLICK,
  NUVEM_DOMAINS_CHECKOUT,
  NUVEM_DOMAINS_ERROR,
  NUVEM_DOMAINS_MANUAL_CONFIG_CLICK,
  NUVEM_DOMAINS_NOT_AVAILABLE,
  NUVEM_DOMAINS_PAYMENT_PROCESS,
  NUVEM_DOMAINS_PAYMENT_REJECTED,
  NUVEM_DOMAINS_PAY_CLICK,
  NUVEM_DOMAINS_SEARCH,
  NUVEM_DOMAINS_START_BUY_CLICK,
  NUVEM_DOMAINS_VALIDATION_PROCESS,
  NUVEM_DOMAINS_VALIDATION_PROCESS_RESEND_CLICK,
  SOFTBLOCK_NAMESERVER_ERROR_SHOW,
  SOFTBLOCK_NAMESERVER_SHOW,
  SOFTBLOCK_NAMESERVER_SKIP,
  SOFTBLOCK_NAMESERVER_TUTORIAL,
  SOFTBLOCK_NAMESERVER_UPDATED,
} from 'config/trackingEvents';

type SourceSoftblock = 'login' | 'domain';

export const trackingAddDomainClick = () => {
  logEvent(ADD_DOMAIN_CLICK, {});
};

export const trackingDeleteDomainClick = () => {
  logEvent(DELETE_DOMAIN_CLICK, {});
};

export const trackingCreateDomainSubmitClick = () => {
  logEvent(CREATE_DOMAIN_SUBMIT_CLICK, {});
};

export const trackingDomainsErrorAlertDashboardClick = () => {
  logEvent(DOMAINS_ERROR_ALERT_DASHBOARD_CLICK, {});
};

export const trackingDomainsErrorAlertDashboardDismiss = () => {
  logEvent(DOMAINS_ERROR_ALERT_DASHBOARD_DISMISS, {});
};

export const trackingDomainErrorReviewClick = () => {
  logEvent(DOMAIN_ERROR_REVIEW_CLICK, {});
};

export const trackingDomainsErrorAlertDashboardShow = () => {
  logEvent(DOMAINS_ERROR_ALERT_DASHBOARD_SHOW, {});
};

export const trackingNuvemDomainsManualConfigClick = () => {
  logEvent(NUVEM_DOMAINS_MANUAL_CONFIG_CLICK, {});
};

export const trackingNuvemDomainsStartBuyClick = () => {
  logEvent(NUVEM_DOMAINS_START_BUY_CLICK, {});
};

export const trackingNuvemDomainsSearch = () => {
  logEvent(NUVEM_DOMAINS_SEARCH, {});
};

export const trackingNuvemDomainsAvailable = () => {
  logEvent(NUVEM_DOMAINS_AVAILABLE, {});
};

export const trackingNuvemDomainsBuyClick = (source: 'cta' | 'chevron') => {
  logEvent(NUVEM_DOMAINS_BUY_CLICK, { source });
};

export const trackingNuvemDomainsNotAvailable = (
  reason: 'already_registered' | 'other_tld',
) => {
  logEvent(NUVEM_DOMAINS_NOT_AVAILABLE, { reason });
};

export const trackingNuvemDomainsCheckout = () => {
  logEvent(NUVEM_DOMAINS_CHECKOUT, {});
};

export const trackingNuvemDomainsPayClick = () => {
  logEvent(NUVEM_DOMAINS_PAY_CLICK, {});
};

export const trackingNuvemDomainsPaymentProcess = () => {
  logEvent(NUVEM_DOMAINS_PAYMENT_PROCESS, {});
};

export const trackingNuvemDomainsPaymentRejected = (
  source: 'checkout' | 'landing',
) => {
  logEvent(NUVEM_DOMAINS_PAYMENT_REJECTED, { source });
};

export const trackingNuvemDomainsError = () => {
  logEvent(NUVEM_DOMAINS_ERROR, {});
};

export const trackingNuvemDomainsValidationProcess = () => {
  logEvent(NUVEM_DOMAINS_VALIDATION_PROCESS, {});
};

export const trackingNuvemDomainsValidationProcessResendClick = () => {
  logEvent(NUVEM_DOMAINS_VALIDATION_PROCESS_RESEND_CLICK, {});
};

export const trackingSoftblockNameserverViewed = (
  storeId: string,
  source: SourceSoftblock,
  isErrorScreen: boolean,
) => {
  const event = isErrorScreen
    ? SOFTBLOCK_NAMESERVER_ERROR_SHOW
    : SOFTBLOCK_NAMESERVER_SHOW;
  logEvent(event, {
    source,
    storeId,
  });
};

export const trackingRememberLaterClick = (
  storeId: string,
  source: SourceSoftblock,
) => {
  logEvent(SOFTBLOCK_NAMESERVER_SKIP, {
    source,
    storeId,
  });
};

export const trackingNotifyChangesClick = (
  storeId: string,
  source: SourceSoftblock,
) => {
  logEvent(SOFTBLOCK_NAMESERVER_UPDATED, {
    source,
    storeId,
  });
};

export const trackingGoToTutorialClick = (
  storeId: string,
  source: SourceSoftblock,
) => {
  logEvent(SOFTBLOCK_NAMESERVER_TUTORIAL, {
    storeId,
    source,
  });
};
